import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const routes = [
  {
    path: "/Login",
    component: () => import("@/views/dashboard/Login"),
  },
  {
    path: "/",
    component: () => import("@/views/dashboard/Index"),
    children: [
      {
        name: "Welcom Kinan",
        path: "",
        component: () => import("@/views/dashboard/Dashboard"),
      },
      {
        name: "Investment Requirements",
        meta: { isPublic: true },
        path: "investmentRequirements",
        component: () =>
          import("@/views/dashboard/modules/required-project/formUsers"),
      },
      {
        name: "Temp Page",
        meta: { isPublic: true },
        path: "tempPage",
        component: () =>
          import("@/views/dashboard/modules/required-project/tempPage"),
      },
    ],
  },
  
];

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
